// removed by extract-text-webpack-plugin
module.exports = {"gstNotice":"_34rXl"};